import arrayMove           from '../Lib/helpers/array-move';
import ActivePaletteModule from "./ActivePalette";
import indexWhereId        from "../Lib/helpers/indexWhereId";

export default {
    namespaced: true,

    modules: { ActivePalette: ActivePaletteModule },

    state: {
        palettes: [],
    },

    mutations: {
        setPalettes(state, data) {
            state.palettes = data;
        },

        removePalette(state, id) {
            state.palettes.splice(indexWhereId(state.palettes, id), 1);
        },

        reorder(state, { oldIndex, newIndex }) {
            state.palettes = arrayMove(state.palettes, oldIndex, newIndex);

            for(let i in state.palettes) {
                state.palettes[i].position = i;
            }
        },

        reorderSwatches({ palettes }, { oldIndex, newIndex, paletteId }) {
            let paletteIndex = indexWhereId(palettes, paletteId);
            let palette = palettes[paletteIndex];

            palette.swatches = arrayMove(palette.swatches, oldIndex, newIndex);

            for(let i in palette.swatches) {
                palette.swatches[i].position = i;
            }

            palettes[paletteIndex] = palette;
        },

        updateName(state, { paletteId, name }) {
            state.palettes[indexWhereId(state.palettes, paletteId)].name = name
        },

        updateNotes(state, { paletteId, notes }) {
            state.palettes[indexWhereId(state.palettes, paletteId)].notes = notes;
        },

        add({ palettes }, data) {
            palettes.unshift(data);
        },

        pushSwatch(state, { swatch, paletteId }) {
            let paletteIndex = indexWhereId(state.palettes, paletteId);

            state.palettes[paletteIndex].swatches.push(swatch);
        },

        setSwatchColor(state, { paletteId, swatchIndex, color }) {
            let paletteIndex = indexWhereId(state.palettes, paletteId);

            state.palettes[paletteIndex].swatches[swatchIndex].color = color
        },

        removeSwatch(state, { paletteId, swatchIndex }) {
            let paletteIndex = indexWhereId(state.palettes, paletteId);

            state.palettes[paletteIndex].swatches.splice(swatchIndex, 1);
        },

    },

}
